<template>
    <div class="form">
        <h4 class="step-title">
            What is your credit rating?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <scrollable-button-list v-bind:items="creditRatings" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"

    export default {
        name: "CreditRating",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                creditRatings: [
                    { text: "Excellent", value: "Excellent" },
                    { text: "Good", value: "Good" },
                    { text: "Average", value: "Okay" },
                    { text: "Below Average", value: "BelowAverage" },
                    { text: "Poor", value: "Poor" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(creditRating) {
                this.lead.creditRating = creditRating;
                this.$emit("complete", this.$options.name, creditRating);
            }
        }
    }
</script>
